/**
 * Created by vwiny on 11/19/2018.
 */
import { Injectable, ViewContainerRef } from '@angular/core';
import { SohoModalDialogRef, SohoModalDialogService } from 'ids-enterprise-ng';
import { Observable, Subject } from 'rxjs';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMBannerUserContextDialogComponent } from './lm-banner-usercontext-dialog.component';
import { LMDialogButtonKey, LMUniqueIdService } from '@utils/index';

export enum LMBannerUserContextDialogStatus {
  RESPONSE_CANCEL = 0,
  RESPONSE_OK,
  RESPONSE_SAVED
}

export interface LMBannerUserContextResult {
  status: LMBannerUserContextDialogStatus;
  userContextFields?: LMBannerUserContextField[];
  userContextProperties?: { [ key: string ]: LMBannerUserContextModelField };
  saveChanges: boolean;
}

@Injectable()
export class LMBannerUserContextDialogService {

  constructor(
    private sohoModalDialogService: SohoModalDialogService,
    private lmLoggerService: LMLoggerService,
    private lmUniqueIdService: LMUniqueIdService
  ) {
  }

  /**
   * Prompt User Context dialog
   * @param viewContainerRef
   *
   * @return Observable<any>
   */
  public promptUserContextDialog(placeholder: ViewContainerRef, userContextFields: LMBannerUserContextField[]): Observable<LMBannerUserContextResult> {
    return new Observable<LMBannerUserContextResult>(observer => {
      this.lmLoggerService.log([ 'LMReportPersonalizationDialog', 'formService.getFormSpec()', 'Complete' ]);

      const userContextDialog$: Subject<LMBannerUserContextResult> = new Subject<LMBannerUserContextResult>();
      let dlgComponent: LMBannerUserContextDialogComponent;
      let dialog: SohoModalDialogRef<any>;

      const dialogId = 'ActorContext';
      const buttons = [
        {
          id: this.lmUniqueIdService.uniqueId([dialogId, LMDialogButtonKey.CANCEL]),
          text: Soho.Locale.translate(LMDialogButtonKey.CANCEL),
          click: (e, modal) => {
            modal.isCancelled = true;
            dialog.close(<LMBannerUserContextResult>{
              status: LMBannerUserContextDialogStatus.RESPONSE_CANCEL
            });
          }
        },
        {
          id: this.lmUniqueIdService.uniqueId([dialogId, LMDialogButtonKey.OK]),
          text: Soho.Locale.translate(LMDialogButtonKey.OK),
          click: (e, modal) => {
            dialog.close(<LMBannerUserContextResult>{
              status:                LMBannerUserContextDialogStatus.RESPONSE_OK,
              userContextFields:     dlgComponent.userContextFields,
              userContextProperties: dlgComponent.model,
              saveChanges:           dlgComponent.saveChanges
            });
          },
          validate: false,
          isDefault: true
        }
      ];
      dialog = this.sohoModalDialogService
        .modal(LMBannerUserContextDialogComponent, placeholder, {fullsize: 'responsive'})
        .buttons(buttons)
        .title(Soho.Locale.translate('ActorContextDialogTitle'))
        .isAlert(false)
        .open()
        .apply((UserContextForm: LMBannerUserContextDialogComponent) => {
          dlgComponent = UserContextForm;
          if (userContextFields) {
            dlgComponent.userContextFields = userContextFields;
          }
          dlgComponent.dialog$ = userContextDialog$;
        })
        .afterClose(result => {
          observer.next(result);
          observer.complete();
        });

      userContextDialog$.subscribe((result: LMBannerUserContextResult) => {
        if (result.status === LMBannerUserContextDialogStatus.RESPONSE_SAVED) {
          userContextDialog$.complete();
          dialog.close(result);
        }
      });
    });
  }
}
